module.exports = __webpack_public_path__ + "static/img/1_5_1.f18ea51e.jpg";